/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_CoveredInputs */

const en_signin_sso_covered = /** @type {(inputs: Signin_Sso_CoveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your company signs in with its single sign-on service. Continue there with this email address.`)
};

/** @type {(inputs: Signin_Sso_CoveredInputs) => LocalizedString} */
const ar_signin_sso_covered = en_signin_sso_covered;

/** @type {(inputs: Signin_Sso_CoveredInputs) => LocalizedString} */
const he_signin_sso_covered = en_signin_sso_covered;

/** @type {(inputs: Signin_Sso_CoveredInputs) => LocalizedString} */
const ur_signin_sso_covered = en_signin_sso_covered;

/** @type {(inputs: Signin_Sso_CoveredInputs) => LocalizedString} */
const es_signin_sso_covered = en_signin_sso_covered;

/** @type {(inputs: Signin_Sso_CoveredInputs) => LocalizedString} */
const fr_signin_sso_covered = en_signin_sso_covered;

/** @type {(inputs: Signin_Sso_CoveredInputs) => LocalizedString} */
const de_signin_sso_covered = en_signin_sso_covered;

/** @type {(inputs: Signin_Sso_CoveredInputs) => LocalizedString} */
const pt_signin_sso_covered = en_signin_sso_covered;

/** @type {(inputs: Signin_Sso_CoveredInputs) => LocalizedString} */
const hi_signin_sso_covered = en_signin_sso_covered;

/** @type {(inputs: Signin_Sso_CoveredInputs) => LocalizedString} */
const bn_signin_sso_covered = en_signin_sso_covered;

/**
* | output |
* | --- |
* | "Your company signs in with its single sign-on service. Continue there with this email address." |
*
* @param {Signin_Sso_CoveredInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_sso_covered = /** @type {((inputs?: Signin_Sso_CoveredInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_CoveredInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_sso_covered(inputs)
	if (locale === "he") return he_signin_sso_covered(inputs)
	if (locale === "ur") return ur_signin_sso_covered(inputs)
	if (locale === "es") return es_signin_sso_covered(inputs)
	if (locale === "fr") return fr_signin_sso_covered(inputs)
	if (locale === "de") return de_signin_sso_covered(inputs)
	if (locale === "pt") return pt_signin_sso_covered(inputs)
	if (locale === "hi") return hi_signin_sso_covered(inputs)
	if (locale === "bn") return bn_signin_sso_covered(inputs)
	return /** @type {LocalizedString} */ ("Your company signs in with its single sign-on service. Continue there with this email address.")
});